import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17c7172d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "controls" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "FREQUENCY", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "REPEAT", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" TRANSMIT ")

import ButtonComponent from '@/components/ButtonComponent.vue';
import DropdownComponent from '@/components/DropdownComponent.vue';
import Icon from '@/components/icon/Icon';
import {
  BuildableDialogItem,
  MessageBroadcast,
  RadioBroadcastPayload
} from '@/models/BuildableDialogItem';
import { DropdownOptions } from '@/models/Forms/FormOptions';
import { computed, Ref, ref } from 'vue';
import RepeatsIncrementer from '@/components/system/components/giantVoice/RepeatsIncrementer.vue';
import { RadioComposable } from '../../../../ecs/radio/RadioComposable';
import { radioAvailableDialog } from '../../../../models/RadioDialogItem';
import IconComponent from '../../../icon/IconComponent.vue';
import BuildableDialogueBodyWidget from '../buildableDialog/BuildableDialogueBodyWidget.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioBodyWidget',
  props: {
    radio: null
  },
  setup(__props: any) {

const props = __props as {
  radio: RadioComposable;
}



const builtDialogMessage: Ref<BuildableDialogItem[]> = ref([]);
const repeats: Ref<number> = ref(0);
const frequency: Ref<string> = ref('');

const availibleDialogItems = radioAvailableDialog;

const REMOVABLE_INDEX = -1;
const removeableIndex = ref(REMOVABLE_INDEX);

const transmitDisabled = computed(() => {
  return builtDialogMessage.value.length < 1;
});

const addDialogToBuiltDialogMessage = (dialogItem: BuildableDialogItem) => {
  builtDialogMessage.value.push({ ...dialogItem });
};

const removeDialog = (index: number) => {
  builtDialogMessage.value.splice(index, 1);
};

const incrementRepeatsUp = () => {
  repeats.value++;
};

const incrementRepeatsDown = () => {
  if (repeats.value <= 0) {
    return;
  }
  repeats.value--;
};

const clearBuiltDialog = () => {
  builtDialogMessage.value = [];
  removeableIndex.value = REMOVABLE_INDEX;
};

const transmitCommand = () => {
  const message = builtDialogMessage.value
    .map((item) => {
      return item.textValue;
    })
    .join(' ');
  const builtRadioTransmit: RadioBroadcastPayload = {
    message,
    repeats: repeats.value,
    frequency: frequency.value
  };
  const broadcast: MessageBroadcast<string> = {
    messageType: 'Media Session',
    payload: JSON.stringify(builtRadioTransmit)
  };
  props.radio.sendMessage(broadcast);
  clearBuiltDialog();
};
const dropdownValues: DropdownOptions[] = [
  { label: 'Flightline' },
  { label: 'General' },
  { label: 'Tower' },
  { label: 'Channel 7' }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(BuildableDialogueBodyWidget, {
      "available-dialog": _unref(availibleDialogItems),
      builtDialogMessage: builtDialogMessage.value,
      onAddDialog: addDialogToBuiltDialogMessage,
      onClear: _cache[2] || (_cache[2] = ($event: any) => (builtDialogMessage.value = [])),
      onRemoveDialog: removeDialog
    }, {
      controls: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _hoisted_2,
            _createVNode(DropdownComponent, {
              class: "w-48",
              placeholder: "Select Option",
              modelValue: frequency.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((frequency).value = $event)),
              values: dropdownValues,
              isClearable: false,
              "left-icon-value": _unref(Icon).CLOCK_EMPHASIZED
            }, null, 8, ["modelValue", "left-icon-value"])
          ]),
          _createElementVNode("div", null, [
            _hoisted_3,
            _createVNode(RepeatsIncrementer, {
              modelValue: repeats.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((repeats).value = $event)),
              onOnLeftSelect: incrementRepeatsDown,
              onOnRightSelect: incrementRepeatsUp
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(ButtonComponent, {
            class: "self-center h-full mt-7 w-42",
            "data-testid": "clear-button",
            "color-type": "tertiary",
            disabled: _unref(transmitDisabled),
            size: "large",
            onClick: transmitCommand
          }, {
            default: _withCtx(() => [
              _createVNode(IconComponent, {
                icon: _unref(Icon).PLAY,
                class: "mr-2"
              }, null, 8, ["icon"]),
              _hoisted_4
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["available-dialog", "builtDialogMessage"])
  ]))
}
}

})